/* GladGirl accessibility fixes (GG a11y 2026-10-27, unpublished preview theme). Theme-only, no settings changed.
   Everything is delegated on document / re-applied by a MutationObserver, so it survives InstantClick page swaps
   and AJAX re-renders. Rollback: remove the gg-a11y.css / gg-a11y.js lines from layout/theme.liquid. */
(function () {
  if (window.__ggA11y) return; window.__ggA11y = 1;
  var d = document;
  function $all(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function vis(el) { return !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden'; }
  function focusables(root) {
    return $all('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root).filter(vis);
  }

  /* ---------- Live region (4.1.3): add-to-bag / cart updates ---------- */
  var live;
  function say(msg) {
    if (!live) { live = d.createElement('div'); live.className = 'gg-vh'; live.setAttribute('aria-live', 'polite'); live.setAttribute('role', 'status'); live.id = 'gg-live'; }
    if (!live.isConnected) d.body.appendChild(live);
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60);
  }
  try {
    var XO = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (/\/cart\/add(\.js)?(\?|$)/.test(String(u))) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) say('Added to bag.'); else if (this.status === 422) say('Could not add to bag.'); }); } catch (e) {}
      return XO.apply(this, arguments);
    };
  } catch (e) {}

  /* ---------- Generic keyboard activation for role=button elements that aren't native buttons ---------- */
  var KBD = '.mobile_nav[role=button], .js-change-quantity[role=button], .gg-acc-btn[role=button]';
  d.addEventListener('keydown', function (e) {
    var t = e.target; if (!t || !t.matches || !t.matches(KBD)) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      if (e.key === 'Enter' && t.hasAttribute('onkeypress')) return; /* legacy inline handler already clicks */
      e.preventDefault(); t.click();
    }
  });

  /* ---------- Mobile menu (#1): aria-expanded, focus into drawer, trap, return focus ---------- */
  var drawerOpen = false;
  function drawer() { return d.querySelector('#header .dropdown_container[data-dropdown="menu"]'); }
  function syncDrawer() {
    var dr = drawer(), btn = d.querySelector('#header .mobile_nav'); if (!dr || !btn) return;
    var open = getComputedStyle(dr).display !== 'none' && vis(dr);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !drawerOpen) {
      drawerOpen = true;
      var c = dr.querySelector('.mobile-drawer-close') || focusables(dr)[0];
      if (c) setTimeout(function () { try { c.focus(); } catch (e) {} }, 30);
    } else if (!open && drawerOpen) {
      drawerOpen = false;
      var a = d.activeElement;
      if (!a || a === d.body || dr.contains(a)) { try { btn.focus(); } catch (e) {} }
    }
  }
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawerOpen) return;
    var dr = drawer(); if (!dr) return;
    var f = focusables(dr); if (!f.length) return;
    var a = f[0], z = f[f.length - 1], cur = d.activeElement;
    if (!dr.contains(cur)) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && cur === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && cur === z) { e.preventDefault(); a.focus(); }
  });

  /* ---------- Cart icon name (#12): "Bag, N items" (keeps the visible count in the name) ---------- */
  function syncCartLinks() {
    $all('a.mini_cart').forEach(function (a) {
      var c = a.querySelector('.cart_count'); var n = c ? c.textContent.trim() : '';
      var want = 'Bag, ' + n + (n === '1' ? ' item' : ' items');
      if (n !== '' && a.getAttribute('aria-label') !== want) a.setAttribute('aria-label', want);
    });
  }

  /* ---------- Hidden sticky header clone (#5/#19): out of tab order until it is actually shown ---------- */
  function syncSticky() {
    $all('.sticky_nav').forEach(function (s) {
      var shown = s.classList.contains('sticky_nav--stick');
      if (shown) { if (s.hasAttribute('inert')) { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); } }
      else if (!s.hasAttribute('inert')) { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
    });
  }

  /* ---------- Footer accordions (#6): button semantics on mobile only, heading level fixed (#20) ---------- */
  var accN = 0, FOOT_MQ = window.matchMedia('(max-width: 798px)');
  function syncFooter() {
    $all('.footer_menu > h6, .footer_content > h6').forEach(function (h) {
      if (h.getAttribute('role') !== 'heading') { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); }
      var panel = h.nextElementSibling; if (!panel) return;
      var btn = h.querySelector(':scope > .gg-acc-btn');
      if (!btn) {
        btn = d.createElement('span'); btn.className = 'gg-acc-btn';
        while (h.firstChild) btn.appendChild(h.firstChild);
        h.appendChild(btn);
        var ic = btn.querySelector('.icon-down-arrow'); if (ic) ic.setAttribute('aria-hidden', 'true');
      }
      if (!panel.id) panel.id = 'gg-footer-panel-' + (++accN);
      var isAccordion = FOOT_MQ.matches; /* theme: .footer .toggle_content is forced open at medium-up */
      if (isAccordion) {
        if (btn.getAttribute('role') !== 'button') { btn.setAttribute('role', 'button'); btn.setAttribute('tabindex', '0'); btn.setAttribute('aria-controls', panel.id); }
        var ex = vis(panel) ? 'true' : 'false';
        if (btn.getAttribute('aria-expanded') !== ex && !btn.__ggAnim) btn.setAttribute('aria-expanded', ex);
      } else if (btn.hasAttribute('role')) {
        ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (a) { btn.removeAttribute(a); });
      }
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.gg-acc-btn[role=button]'); if (!b) return;
    var p = d.getElementById(b.getAttribute('aria-controls'));
    b.setAttribute('aria-expanded', p && vis(p) ? 'false' : 'true'); /* toggled by the theme's slideToggle right after */
    b.__ggAnim = 1; setTimeout(function () { b.__ggAnim = 0; syncFooter(); }, 600);
  });

  /* ---------- Product swatches (#2): radios stay real & focusable; sold-out state in the accessible name ---------- */
  function syncSwatches() {
    $all('.swatch_options .swatch input[type=radio][data-gg-value]').forEach(function (i) {
      var el = i.nextElementSibling; if (!el || !el.classList.contains('swatch-element')) return;
      var want = i.getAttribute('data-gg-value') + (el.classList.contains('soldout') ? ' – sold out' : '');
      if (i.getAttribute('aria-label') !== want) i.setAttribute('aria-label', want);
    });
  }

  /* ---------- Hero slideshow (#8): Pause/Play control, off-screen slides inert. Autoplay setting untouched. ---------- */
  function syncSlideshows() {
    if (!window.jQuery) return;
    $all('.js-homepage-slideshow.flickity-enabled').forEach(function (el) {
      var $el = window.jQuery(el), f = $el.data('flickity'); if (!f) return;
      var cells = $all('.gallery-cell', el);
      function inertCells() {
        cells.forEach(function (c) {
          var sel = c.classList.contains('is-selected');
          if (sel && c.hasAttribute('inert')) c.removeAttribute('inert');
          else if (!sel && !c.hasAttribute('inert')) c.setAttribute('inert', '');
        });
      }
      if (el.__ggSS) { inertCells(); return; }
      el.__ggSS = 1;
      if (!f.options.autoPlay || cells.length < 2) { $el.on('select.flickity', inertCells); inertCells(); return; }
      var btn = d.createElement('button'); btn.type = 'button'; btn.className = 'gg-ss-toggle';
      function paint() {
        var playing = f.player && f.player.state !== 'stopped';
        btn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
        btn.innerHTML = playing ? '<span aria-hidden="true" class="gg-ss-i">&#10073;&#10073;</span><span class="gg-ss-t">Pause</span>' : '<span aria-hidden="true" class="gg-ss-i">&#9654;</span><span class="gg-ss-t">Play</span>';
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (f.player && f.player.state !== 'stopped') $el.flickity('stopPlayer'); else $el.flickity('playPlayer');
        paint();
      });
      el.appendChild(btn); paint();
      /* WCAG 2.2.2: also pause while keyboard focus is inside the slideshow */
      el.addEventListener('focusin', function () { if (f.player && f.player.state === 'playing') f.player.pause(); });
      el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget) && f.player && f.player.state === 'paused') f.player.unpause(); });
      $el.on('select.flickity', function () { inertCells(); paint(); });
      $el.on('pointerDown.flickity', function () { setTimeout(paint, 0); });
      inertCells();
    });
  }

  /* ---------- Skip link (#5) ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.gg-skip-link'); if (!a) return;
    var m = d.getElementById('MainContent'); if (!m) return;
    e.preventDefault(); m.focus(); try { m.scrollIntoView(); } catch (x) {}
  });


  /* ---------- v2: predictive search (#13): results reachable by arrow keys, Esc closes, count announced ---------- */
  var srN = 0;
  function syncSearch() {
    $all('form input[name="q"]').forEach(function (inp) {
      var ul = inp.form && inp.form.querySelector('.search__results'); if (!ul) return;
      if (!ul.id) ul.id = 'gg-search-results-' + (++srN);
      if (inp.getAttribute('aria-controls') !== ul.id) inp.setAttribute('aria-controls', ul.id);
      if (inp.getAttribute('role') !== 'combobox') { inp.setAttribute('role', 'combobox'); inp.setAttribute('aria-autocomplete', 'list'); }
      if (!ul.hasAttribute('aria-label')) ul.setAttribute('aria-label', 'Search suggestions');
      var n = $all('li a[href]', ul).length, open = n > 0 && vis(ul);
      var ex = open ? 'true' : 'false';
      if (inp.getAttribute('aria-expanded') !== ex) inp.setAttribute('aria-expanded', ex);
      if (open && ul.__ggN !== n) { ul.__ggN = n; if (d.activeElement === inp) say(n + (n === 1 ? ' suggestion' : ' suggestions') + '. Press Down arrow to browse.'); }
      if (!open) ul.__ggN = 0;
    });
  }
  d.addEventListener('keydown', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var form = t.closest('form'); if (!form) return;
    var ul = form.querySelector('.search__results'); if (!ul || !vis(ul)) return;
    var links = $all('li a[href]', ul).filter(vis); if (!links.length) return;
    var inp = form.querySelector('input[name="q"]');
    var i = links.indexOf(t);
    if (e.key === 'ArrowDown') { e.preventDefault(); if (t === inp) inp.__ggNav = true; (links[i + 1] || links[0]).focus(); }
    else if (e.key === 'ArrowUp' && i >= 0) { e.preventDefault(); (i === 0 ? inp : links[i - 1]).focus(); }
    else if (e.key === 'Escape' && (t === inp || i >= 0)) {
      var w = ul.closest('.search__results-wrapper') || ul; if (inp) inp.focus(); w.style.display = 'none'; if (inp) inp.setAttribute('aria-expanded', 'false');
    }
  });

  /* leaving the field by arrow key fires 'change', which makes the theme re-fetch and rebuild the list under the focused link */
  d.addEventListener('change', function (e) {
    var t = e.target; if (t && t.__ggNav && t.name === 'q') { t.__ggNav = false; e.stopImmediatePropagation(); }
  }, true);
  d.addEventListener('input', function (e) { if (e.target && e.target.__ggNav) e.target.__ggNav = false; }, true);

  /* ---------- v2: markup/ARIA cleanup (#21) and third-party names (#18) ---------- */
  function syncMarkup() {
    /* desktop nav: <ul class=menu> holds <div class=vertical-menu> wrappers around the <li>s */
    $all('ul.menu > div').forEach(function (dv) {
      if (!$all(':scope > li', dv).length) return;
      if (dv.getAttribute('role') !== 'list') dv.setAttribute('role', 'list');
      var ul = dv.parentElement; if (ul.getAttribute('role') !== 'none' && !$all(':scope > li', ul).length) ul.setAttribute('role', 'none');
    });
    /* only one banner landmark: third-party app banners (e.g. Tapcart) become plain regions */
    $all('[role="banner"]').forEach(function (b) {
      if (b.tagName === 'HEADER') return;
      b.setAttribute('role', 'region'); if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'App banner');
    });
    /* second visible <header> (mobile header vs desktop header) gets a distinct name */
    var hs = $all('header').filter(function (h) { return vis(h) && !h.closest('.sticky_nav, main, article, section, aside, nav, [role=dialog]'); });
    if (hs.length > 1) hs.forEach(function (h, k) { if (k > 0) { if (h.hasAttribute('aria-label')) h.removeAttribute('aria-label'); if (h.getAttribute('role') !== 'none') h.setAttribute('role', 'none'); } });
    /* Pledge.to impact iframe */
    $all('iframe.plg-impact-iframe:not([title])').forEach(function (f) { f.setAttribute('title', 'Pledge donation impact'); });
    /* Stamped carousel review links with no text */
    $all('a.stamped-reviews-link').forEach(function (a) {
      if (!a.textContent.trim() && !a.getAttribute('aria-label')) a.setAttribute('aria-label', 'Read this review on Stamped');
    });
    /* breadcrumb home link title (missing locale string) */
    $all('a[title="Translation missing: en.general.breadcrumbs.home_link_title"]').forEach(function (a) { a.setAttribute('title', 'Home'); });
  }

  /* ---------- Run + keep in sync ---------- */
  function all() { syncDrawer(); syncCartLinks(); syncSticky(); syncFooter(); syncSwatches(); syncSlideshows(); syncSearch(); syncMarkup(); }
  var t, pend = false;
  function queue() { if (pend) return; pend = true; t = setTimeout(function () { pend = false; all(); }, 120); }
  function start() {
    all();
    if (window.MutationObserver) new MutationObserver(queue).observe(d.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    window.addEventListener('resize', queue);
    if (window.InstantClick && InstantClick.on) { try { InstantClick.on('change', function () { accN = 0; setTimeout(all, 300); }); } catch (e) {} }
    setTimeout(all, 1500); setTimeout(all, 4000);
  }
  /* ---------- Input modality (2026-10-27c): html.gg-kbd only while the keyboard is used, so tap/click focus never draws a ring ---------- */
  var root = d.documentElement;
  d.addEventListener('keydown', function (e) { if ((e.key === 'Tab' || /^Arrow/.test(e.key) || e.key === 'Home' || e.key === 'End') && !e.metaKey && !e.ctrlKey && !e.altKey) root.classList.add('gg-kbd'); }, true);
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) { d.addEventListener(ev, function () { root.classList.remove('gg-kbd'); }, { capture: true, passive: true }); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---- v6 (2026-10-27 ADA follow-up, copy 187753168948): Recharge cart-drawer accent #b47c7d (3.3:1) -> #945657 (5.56:1 on white).
   The drawer lives in Recharge's shadow DOM and sets its colors on an inner element, so theme CSS cannot reach it;
   this adds one small stylesheet inside that shadow root. Recharge admin settings are unchanged. ---- */
(function () {
  var CSS = '#cart-overlay-drawer{--storefront-drawer-accent:#945657 !important;--storefront-drawer-primary:#945657 !important;--storefront-drawer-secondary-foreground:#945657 !important;--storefront-drawer-link:#945657 !important}';
  var sheet = null;
  function fix() {
    var hosts = document.querySelectorAll('#recharge-storefront-experiences__cart-overlay,#recharge-storefront-experiences__cart-drawer');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot; if (!sr) continue;
      try {
        if (!sheet) { sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); }
        var a = sr.adoptedStyleSheets || [];
        if (a.indexOf(sheet) === -1) sr.adoptedStyleSheets = a.concat([sheet]);
      } catch (e) {
        if (!sr.querySelector('style[data-gg-rc]')) { var st = document.createElement('style'); st.setAttribute('data-gg-rc', ''); st.textContent = CSS; sr.appendChild(st); }
      }
    }
  }
  var q = false;
  function queue() { if (q) return; q = true; setTimeout(function () { q = false; fix(); }, 150); }
  function start() {
    fix();
    if (window.MutationObserver) new MutationObserver(queue).observe(document.body || document.documentElement, { childList: true, subtree: true });
    document.addEventListener('click', function () { setTimeout(fix, 400); setTimeout(fix, 1500); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
